import React from 'react';

import type {ModelFilterTechnicalDataGroup} from '@volkswagen-onehub/car-technical-details-bff';
import {Disclaimers, Image, styled} from '@volkswagen-onehub/components-core';

const StyledAccordionBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.size.static300};
`;
export const ImageVisualisation = (props: {
  group: ModelFilterTechnicalDataGroup;
}): JSX.Element => {
  const {group} = props;
  const disclaimerText = group.imagesDisclaimer;
  const disclaimer = {text: disclaimerText};

  return (
    <StyledAccordionBodyWrapper>
      {group.images?.map((image) => (
        <Image src={image.src} alt="" key={image.id} /> // the image is presentational because info is conveyed via the table
      ))}
      {disclaimerText ? (
        <Disclaimers
          aria-hidden // text is hidden because the image UI is hidden from screen readers as a whole
          disclaimers={[disclaimer]}
        />
      ) : null}
    </StyledAccordionBodyWrapper>
  );
};

export default ImageVisualisation;
